import React from 'react';

import {PropositionBetsWidgetProps} from "../models/proposition-bets-widget.props";
import {PropositionBetsWidgetController} from "../proposition-bets-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import classNames from "classnames";
import styles from "../styles/proposition-bets-widget.module.scss";
import {Loader, LoaderProps} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES,} from "../../../core/consts";
import {PropositionBetsWidgetEmptyState} from "./proposition-bets-widget.empty-state";
import {PropositionBetsWidgetSeeAll} from "./proposition-bets-widget.see-all";
import {PropositionBetsWidgetDetailsPopup} from "./proposition-bets-widget.details-popup";
import {PropositionBetsWidgetBets} from "./proposition-bets-widget.bets";

export class PropositionBetsWidgetComponentProps extends PropositionBetsWidgetProps {}

export const PropositionBetsWidgetComponent = ({controller, isPreview, onSeeAllClick}: PropositionBetsWidgetComponentProps) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {componentState, fetchingState} = state;

  const baseProps = {
    controller,
    isPreview
  }

  const seeAllProps = {
    onSeeAllClick,
    controller,
    isPreview
  }

  const loaderProps: LoaderProps = {
    when: componentState === COMPONENT_STATES.loading || fetchingState === FETCHING_STATES.fetching,
    className: classNames(styles.placeholder)
  }

  return (
    <Loader {...loaderProps}>
      <div className={classNames(styles.container, {[styles.small_view]: isSmallView, [styles.preview]: isPreview})}>
        <PropositionBetsWidgetBets {...baseProps}/>
        <PropositionBetsWidgetSeeAll {...seeAllProps}/>
        <PropositionBetsWidgetEmptyState controller={controller}/>
      </div>
      <PropositionBetsWidgetDetailsPopup controller={controller}/>
    </Loader>
  )
};

const settings: ComposeSettings = {
  component: PropositionBetsWidgetComponent,
  propsType: PropositionBetsWidgetComponentProps,
  controllerType: PropositionBetsWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,

  observe: true,
};

export default Compose(settings);
